import {
  SUMMARY_SECTION_TO_STEP_ID,
  sortStepIdsByRegistry,
  type RequestFormStepId,
} from '../config/requestFormStepRegistry';

/** Summary accordion key for each form step (inverse of `SUMMARY_SECTION_TO_STEP_ID`). */
const STEP_ID_TO_SUMMARY_SECTION_KEY: Partial<
  Record<RequestFormStepId, string>
> = {};

for (const [sectionKey, stepId] of Object.entries(SUMMARY_SECTION_TO_STEP_ID)) {
  if (!STEP_ID_TO_SUMMARY_SECTION_KEY[stepId]) {
    STEP_ID_TO_SUMMARY_SECTION_KEY[stepId] = sectionKey;
  }
}

/**
 * Ordered Summary accordion keys for enabled scopes — matches sidebar / `formSteps` nav order.
 * Excludes the Summary step itself (`summary`).
 */
export function resolveOrderedSummarySectionKeys(
  enabledStepIds: readonly RequestFormStepId[],
): string[] {
  return sortStepIdsByRegistry([...enabledStepIds])
    .filter(stepId => stepId !== 'summary')
    .map(stepId => STEP_ID_TO_SUMMARY_SECTION_KEY[stepId])
    .filter((key): key is string => key != null);
}
